angular.module('cvsApp').service('modifyFormOfPaymentService',['networkService', 'xdrService','configManager', 'modifyFormOfPaymentModel', function (NS, XS,CM, MFPM) {
   	
	function modifyFormOfPaymentService (){
		this.modifyFormOfPayment = function(formData,callBackSuccess){
			//get url 
			//var url = CM.getAGPAPIUrl('AGP_MODIFY_FORM_OF_PAYMENT', cvsUtility.queryMap.tokenId, 'Login');
			var url = getModifyPaymentUrl('AGP_MODIFY_FORM_OF_PAYMENT', cvsUtility.queryMap.tokenId, 'Login');
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
					header: {
						'Content-Type': 'application/xml',
						'accept': 'application/xml'
						},
							data:getRequestBody(formData),
							onSuccess:callBackSuccess
					};
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, getRequestBody(formData), xdrSuccess);

					function xdrSuccess (data) {
						MFPM.setResponse(data);
						callBackSuccess(MFPM.getResponse());
					}
				}
				else {
					var promise = NS.post(request);	
					promise.then(function(data, c, d){
						
						MFPM.setResponse(data.data);
						callBackSuccess(MFPM.getResponse());

						//send message to parent					
						//cvsUtility.sendPostMessage("SESSION-ALIVE","modifyFormOfPayment");
						
					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});
				}
			}
							
		}

		function getModifyPaymentUrl(serviceKey, tokenId, tokenType) {
			if (cvsUtility.queryMap.env == "" || cvsUtility.queryMap.env == undefined || cvsUtility.queryMap.apikey == "" || cvsUtility.queryMap.apikey == undefined) {
				return "URL_ERROR";
			} else {
				return CVS.Config.serviceHost[cvsUtility.queryMap.env] + "specialty/payments/modifyFormOfPayment/v2";
			}
			
		}

		var getRequestBody = function(formData){
				var date = new Date();			
				
				var requestJson = {
					modifyFormOfPaymentRequest:{	
						"header": {
							"serviceContext": {
								"appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
								"lineOfBusiness": "Specialty",
                            	"channelName": cvsUtility.queryMap.channel,
								tokenID: cvsUtility.queryMap.tokenId,
								"responseFormat": "XML",
								tokenType: "Login",	
							},
							"securityContext": {
								apiKey:cvsUtility.queryMap.apikey,
								"securityType": "apiKey"
							},		
						},
						"details": {
								timestamp:cvsUtility.getTimeStamp(),
								paymentMethodDetails:{
									paymentMethodId:(formData.transactionMode == 'EDIT' || formData.transactionMode == 'REMOVE') ? formData.paymentMethodId : null,
									accountNumber: (formData.transactionMode == 'ADD') ? formData.encryptedAccountNumber : null,
									routingNumber: (formData.transactionMode == 'ADD') ? formData.routingNumber : null,
									payment: {
										method: (formData.transactionMode == 'ADD') ? formData.payment.method : '',
										type: (formData.transactionMode == 'ADD') ? 'ONETIME' : '',
										frequency: '',
										amount: '',
										fsaIndicator: ''
									},
                                    cardholderName:{
                                        firstName:formData.cardholder.firstName,
                                        middleName:'',
                                        lastName:formData.cardholder.lastName},
                                    billingAddress:{
                                        addressLine1:formData.billingAddress.addressLine1,
                                        addressLine2:formData.billingAddress.addressLine2,
                                        city:formData.billingAddress.city,
                                        state:formData.billingAddress.state,
                                        zipCode:formData.billingAddress.zipCode,
                                        zipCodeExt:formData.billingAddress.zipCodeExt},
                                    expiryDate:{
                                        month:(formData.expiryDate == undefined)?'':formData.expiryDate.month,
                                        year:(formData.expiryDate == undefined)?'':formData.expiryDate.year},
										transactionMode:formData.transactionMode,
									mopForFuture: (formData.transactionMode == 'ADD') ? true : false,
									activeFlag: (formData.transactionMode == 'ADD') ? 'ACTIVE' : '',
                                    relationshipToCardHolder:formData.relationshipToCardHolder,
									achAcceptanceInd: (formData.transactionMode == 'ADD' && formData.payment.method == "CHECK") ? true : '',
                                    createdBy:formData.createdBy
								}
							}
						}  
					}            
				return cvsUtility.JSONToXml(requestJson);
			}			
	}
	
	return new modifyFormOfPaymentService();	
}]);
